import React, {Component} from 'react';
import ReactTooltip from 'react-tooltip';

import {Link} from 'components/ReactRouterDomLocalized';
import FollowButton from './FollowButton';
import CertifiedBlock from './CertifiedBlock';

import '../../sass/headers/headerProfile.scss';
import '../../sass/headers/informationBlock.scss';

import {t} from 'l10n'

import {formatLocation, getGenderText, getAgeText, formatLastOnlineDate} from 'utils/user'
import {getReturnPath, getPaymentUrl} from 'utils/url';

class HeaderFull extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showFullAbout: false,
        }
    }

    render() {
        // todo: about display

        let {
            showModalBlacklist,
            showModalAddBadProfile,
            user,
            certifiedMemberPhotos,
            online,
            stats,
            currentUser,
            match,
            blacklistedByMe,
            denounced,
            followedByMe
        } = this.props;

        let returnPath = getReturnPath({match: match, hashBang: false});

        let userAbout = [], userAboutFull = null;

        if (user.about) {
            userAbout = user.about
                .split("\n")
                .map(function(item) { return item.trim() })
                .filter(function(item) { return !!item });

            userAboutFull = null;

            if (userAbout.length > 3) {
                userAboutFull = userAbout;
                userAbout = userAboutFull.slice(0, 3);
            }
        }

        return (
            <header className="profile-header-full">
                <div className="content">
                    <div className="text-header-profile">
                        <div>
                            <div className="img-profile">
                                <div className="img">
                                    <img src={user.avatar_url} alt="" />
                                </div>
                                <CertifiedBlock certifiedMemberPhotos={certifiedMemberPhotos}/>
                                <div className="info">
                                    <a href={'/membre/conversation/'+encodeURIComponent(user.id)} className="button message">
                                        <div className="icon"/>
                                        <p>Message</p>
                                    </a>
                                    <FollowButton user={user} currentUser={currentUser} followedByMe={followedByMe} returnPath={returnPath}/>
                                    <Link to={getPaymentUrl(returnPath, user.id)} className="button give">
                                        <div className="icon"/>
                                        <p>{t('Give')}</p>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="text-profile">
                            <p className="name">
                                {user.nick}
                                {online ?
                                    <span className="online-status">
                                        <i className="status active"/>
                                        {t('I am online at')} <a href={online.room_url} target="_blank">{online.room_name}</a>
                                    </span>
                                    :
                                    <span className="online-status">
                                        <i className="status"/>
                                        {t('Last online at %1', formatLastOnlineDate(user))}
                                    </span>
                                }
                            </p>
                            <div className="informations">
                                <p>
                                    {getGenderText(user)} <span className="dot"/>
                                    {getAgeText(user)} <span className="dot"/>
                                    {formatLocation(user)}
                                </p>
                            </div>
                            {!this.state.showFullAbout ?
                                <div className="description">
                                    {userAbout.map((line, index) =>  <p key={index} dangerouslySetInnerHTML={{__html: line}}/>)}
                                    {userAboutFull && <p><span className="show-all-text" onClick={()=> this.setState({showFullAbout: true})}>{t('Show more')}</span></p>}
                                </div>
                                :
                                <div className="description">
                                    {userAboutFull.map((line, index) =>  <p key={index} dangerouslySetInnerHTML={{__html: line}}/>)}
                                </div>
                            }

                            <div className="information-block">
                                <div className="item views">
                                    <div className="icon"></div>
                                    <p>{stats.viewCount} {t('views')}</p>
                                </div>
                                <div className="item followers">
                                    <div className="icon"></div>
                                    <p>{stats.followerCount} {t('followers')}</p>
                                </div>

                                {currentUser.isLoggedIn() && !denounced &&
                                    <div className="item denounce">
                                        <div className="icon" data-tip data-for="denounceTooltip"></div>
                                        <p onClick={showModalAddBadProfile}>{t('Denounce')}</p>
                                        <ReactTooltip
                                            id="denounceTooltip"
                                            type="light"
                                            place="top"
                                            class="tooltip-fon"
                                        >
                                            <p>{t('You can denounce this profile to Bob if you think its content is punishable by law and regulations.')}</p>
                                        </ReactTooltip>
                                    </div>
                                }

                                {currentUser.isLoggedIn() &&
                                    <div className="item unblock" onClick={showModalBlacklist}>
                                        <div className="icon"></div>
                                        <p>{!blacklistedByMe ? t('Block') : t('Unblock')}</p>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}

export default HeaderFull;


// WEBPACK FOOTER //
// ./src/components/profile/HeaderFull.js